module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "partno"
  }, [_vm._v("SECTION I")]), _vm._v(" "), _c('h2', {
    staticClass: "parttitle"
  }, [_vm._v("FLYING BLIND")]), _vm._v(" "), _c('div', {
    staticClass: "dispquote"
  }, [_c('p', {
    staticClass: "quote_center"
  }, [_c('b', [_vm._v("The Myth of the Super Survivor")])]), _vm._v(" "), _c('p', {
    staticClass: "quotej"
  }, [_c('i', [_vm._v("There is a literature of people who started as mere mortals and then, after surviving some enormous adversity, turned that adversity into a benefit and became very accomplished in one way or another. This is an effective way to think about your life. Because most people don’t think about their life until it’s too late. Then, they think only about their regrets.")])]), _vm._v(" "), _c('p', {
    staticClass: "quote_center"
  }, [_c('b', [_vm._v("—Russell Redenbaugh")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 84
// module chunks = 0